import { useApi } from "hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
  realName: "string",
  birthDate: "2023-02-24T15:54:31.965Z",
  lang: "ha_ER",
  gender: 1,
  countryId: 0,
  bio: "string"
 */


const useUpdateProfile = () => {

  const { apiFetch } = useApi()
  const queryClient = useQueryClient()

  const url = `/me/profile`;
  const method = 'PATCH'


  const updateProfile = (data) => {
    return apiFetch({
      url,
      method,
      data: {
        // realName: "string",
        // birthDate: "2023-02-24T15:54:31.965Z",
        lang: data.lang,
        // gender: 1,
        // countryId: 0,
        // bio: "string"
      }
    })
  }

  const {
    mutateAsync,
    ...rest
  } = useMutation({
    mutationFn: updateProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ predicate: (query) => query.queryKey.includes('lang') })
    }
  })

  return {
    updateProfile: mutateAsync,
    ...rest,
  }
}

export default useUpdateProfile;